var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "totals-box mb-2" }, [
    _c(
      "div",
      { staticClass: "totals-info-wrapper col" },
      [
        _c(
          "router-link",
          {
            attrs: {
              to: { path: "/jobs/edit/" + _vm.total.job_id },
              target: "_blank"
            }
          },
          [
            _c("div", { staticClass: "total-ref-id pointer" }, [
              _vm._v(_vm._s(_vm.total.ref_id))
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "total-info" }, [
          _vm._v("\n      " + _vm._s(_vm.total.move_date) + "\n    ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info" }, [
        _vm._v("\n      " + _vm._s(_vm.total.customer) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info" }, [
        _vm._v("\n      " + _vm._s(_vm.total.mover) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info" }, [
        _vm._v("\n      " + _vm._s(_vm.total.total_time) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info-numbers" }, [
        _vm._v("\n      " + _vm._s(_vm.total.hourly_price) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info-numbers col-width-40" }, [
        _vm._v("\n      " + _vm._s(_vm.total.tips) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info-numbers col-width-40" }, [
        _vm._v("\n      " + _vm._s(_vm.total.extras) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "totals-info-wrapper col" }, [
      _c("div", { staticClass: "total-info-numbers col-width-50" }, [
        _vm._v("\n      " + _vm._s(_vm.total.amount) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "totals-info-wrapper d-flex flex-row position-relative col"
      },
      [
        _c("div", { staticClass: "total-info-numbers status pointer" }, [
          _vm.isPaid
            ? _c(
                "span",
                {
                  class: "btn-status btn-active",
                  on: {
                    click: function($event) {
                      _vm.markAsPaid(_vm.total)
                    }
                  }
                },
                [_c("span", [_vm._v("\n          paid\n        ")])]
              )
            : _c(
                "span",
                {
                  class: "btn-status btn-pending",
                  on: {
                    click: function($event) {
                      _vm.markAsPaid(_vm.total)
                    }
                  }
                },
                [_c("span", [_vm._v("\n          unpaid\n        ")])]
              )
        ]),
        _vm._v(" "),
        !_vm.isPaid
          ? _c("div", { staticClass: "total-info-numbers menu" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  attrs: {
                    "aria-labelledby": "dropdownMenuButtonEditExpenseDiscount"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item p-1 small",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          _vm.markAsPaid(_vm.total)
                        }
                      }
                    },
                    [_vm._v("\n          Mark as paid")]
                  )
                ]
              )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        attrs: {
          id: "dropdownMenuButtonEditExpenseDiscount",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("i", {
          staticClass: "fa fa-ellipsis-h text-secondary menu-icon",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9742ac6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9742ac6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/MoverTotalsBlock.vue
// module id = null
// module chunks = 